import React, { useEffect, useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import HistoryIcon from '@mui/icons-material/History';
import { Link, useNavigate, useParams } from 'react-router-dom';
import S from '../..//pages/ListDam.module.css'
import D from '../../images/history.svg'
import Gadjet from '../../images/gadjet.svg'

import {  useSelector } from 'react-redux';



import { ArrowBack, ArrowForward, DateRange, DateRangeRounded, Key, KeyboardBackspace, Report, Sell, Sensors, SplitscreenOutlined } from '@mui/icons-material';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import apiService from '../../api/ApiService';
import useHistoryCycle from '../CustomHooks/useHistoryCycle';
import { Pagination, Tab, Tabs } from '@mui/material';
import HistoryCardList from '../cardThemes/historyCard';
import EmptyReturn from '../EmptyReturn';
import StatusHistoryCompare from '../HistoryCompare/StatusHistoryCompare';
import { useGlobalContext } from '../Context';
const moment=require('moment-jalaali')
export default function History(props) {
  const {selectedDayRange, setSelectedDayRange,data,page,handlePage,total,handleChange,value,SData,setSdata,setImportancelevel,importanceLevel,importanceList}=useHistoryCycle(props)
  const {openModalls,isOpenModal}=useGlobalContext()
  const {currentTheme}=useSelector(state=>state.p.admin)
  const renderCustomInput = ({ ref }) => (
    <>
      
      <input
    name="birth"
    autoComplete="off"
    ref={ref} // necessary
    placeholder='تاریخ تولد'
    value={selectedDayRange.from?`از ${selectedDayRange.from?.year}/${selectedDayRange.from?.month}/${selectedDayRange.from?.day}  تا  ${selectedDayRange.to?.year?selectedDayRange.to?.year:'-'}/${selectedDayRange.to?.month?selectedDayRange.to?.month:'-'}/${selectedDayRange.to?.day?selectedDayRange.to?.day:'-'}`:''}
    className="opop2" // a styling class
  />
  <label for="" class="labelSS9"><DateRangeRounded/>فیلتر بر اساس بازه زمانی</label>
  
    </>
  )

  return (
    <div className={S.AllAnimalssLICon}>
      <div style={{display:'flex',justifyContent:'center'}}>
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="dark"
        indicatorColor="secondary"
        aria-label="secondary tabs example"
      >
        <Tab value="0" label="خوانده نشده" />
        <Tab value="1" label="خوانده شده " />
      </Tabs>
      </div>
        <div style={{display:'flex',justifyContent:'space-between',direction:'ltr'}}>
        <div class="inputContainerSS">
                           <DatePicker
                           value={selectedDayRange}
                           onChange={setSelectedDayRange}
                             locale='fa'
                             calendarClassName="birthCalender"
                             renderInput={renderCustomInput}
                             />
                             
                           
                              
                       </div>
                       {/* <select value={importanceLevel} onChange={(e)=>{setImportancelevel(e.target.value)}} style={{direction:'rtl',alignSelf:'end'}}   id='sele'  name='sele' className={`selectInp ${S.selectStyle}`}  >
    <option  value={'null'} >فیلتر بر اساس اهمیت</option>
    {importanceList.map((item,index)=>{
      return <option key={index} value={item.id} >{item?.description}</option>
    })}        
                            
                       
                    </select> */}
        </div>
                       
        {!currentTheme&&<div className={S.TabForAllAnnimLICon}>
          
          
          <div className={S.AnimContentLI} style={{borderTopLeftRadius:'0px'}} data-aos='fade'>
          {data.length?<table>
              <thead>
              <tr>
                  <th>
                  <div className='LogoFormT'><div><span>
                <SplitscreenOutlined/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <ArrowForward/>
                </span>
                    </div></div>
                  </th><th>
                  <div className='LogoFormT'><div><span>
                <ArrowBack/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                  </th>
                  
                  <th>
                 <div className='LogoFormT'><div><span>
                <Sensors/>
                </span>
                    </div></div>
                 </th>
                 <th>
                 <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>
                 </th>
                 <th>
                 <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>
                 </th>
                 <th>
                  <div className='LogoFormT'><div><span>
                    <img style={{width:'20px',height:'20px'}} src={Gadjet}/>
                </span>
                    </div></div>
                  </th>
                  {value==0&&<th>
                  <div className='LogoFormT'><div><span>
                    <Report/>
                </span>
                    </div></div>
                  </th>}
                </tr>
                <tr>
                <th>
                    ردیف
                  </th>
                 <th>
                  مقدار گذشته
                 </th>
                 <th>
                  مقدار حال
                 </th>
                  <th>
                     تاریخ
                  </th>
                  
                  <th>شماره سنسور</th>
                  <th>شماره گوش</th>
                  <th>شماره بدن</th>
                  <th>شماره گردنبند</th>
                  {value==0&&<th> مشاهده</th>}

                </tr>
              </thead>
              <tbody>
                {
                  data?.length&&data?.map((item,index)=>{
                    const {entryDate}=item;
                    const birth=entryDate?.substring(0,10);
                    const pbirth=moment(birth).format('jYYYY-jMM-jDD HH:mm')
                    return <tr key={index}>
                    <td>
                    {(index+1)+(page==0?0:page-1)*8}
                    </td>
                    <td>
                      {item?.oldCattleLifeCycleTitle}
                    </td>
                    <td>
                      {item?.newCattleLifeCycleTitle}
                    </td>
                    <td>
                      {pbirth}
  
                    </td>
                    <td className={S.DetIc}>
                      {item?.cattleSensorDeviceCode?item?.cattleSensorDeviceCode:'---'}
                    </td>
                    <td className={S.DetIc}>
                      {item?.cattleEarTagNumber}
                    </td>
                    <td className={S.DetIc}>
                      {item?.cattleBodyNumber}
                    </td>
                    <td className={S.DetIc}>
                      {item?.cattleNecklaceNumber?item?.cattleNecklaceNumber:'---'}
                    </td>
                    {value==0&&<td>
                    <div  onClick={()=>{
                      setSdata(item);openModalls()
                    }} className='btnCardDAm'>متوجه شدم</div>
                    </td>}
                  </tr>
                  
                  })
                }
                
                
                
                
                

              </tbody>
            </table>:<EmptyReturn/>}
          </div>
        </div>}
        {currentTheme&&<HistoryCardList flag={'cycle'} value={value} setSdata={setSdata} data={data}/>}
        <div className='PaginateContainer'>
            <Pagination defaultPage={1} count={total} page={page==0?page+1:page} onChange={handlePage} variant="outlined" color="primary"  boundaryCount={2}/>
            </div>
            {isOpenModal&&<StatusHistoryCompare flag={'cycle'} SData={SData}/>}
    </div>
  );
}